import Login from './indexC'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import {
  onAuthStateChanged,
  onUserNameChanged,
  onUserCreating,
  onEmailExpiration
} from '../../reducers/authState'

const mapStateToProps = state => {
  const { login, emailUnverified } = state.authState
  return {
    login: login,
    emailUnverified: emailUnverified
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateName: name => dispatch(onUserNameChanged(name)),
    onCreateUser: creating => dispatch(onUserCreating(creating)),
    onEmailExpiration: () => dispatch(onEmailExpiration()),
    onAuthStateChanged: authState => dispatch(onAuthStateChanged(authState)),
    goTo: (to) => dispatch(push(to))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)



// WEBPACK FOOTER //
// ./src/components/UserLogin/index.js